// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11k5x","content":"styles_content__2NFYI"};